import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

export class RestrictedAccess extends React.Component {
    render() {
        if (this.props.userChecked) {
            return <div id="page-wrapper" className="white padding-2p-on-mobile border-on-tablet margin-1p-on-tablet ">
                <div className="padding-sides-medium">
                    <div className="error-message text-left">
                        <span className="icon ico-alert"></span>
                        <span>Vaša prijava je istekla, prijavite se ponovno.</span>
                    </div>
                    <NavLink className="btn medium fill blue" to={{ pathname: "/login", state: { from: this.props.route.location } }}>
                        Prijavi me
                    </NavLink>
                </div>

                <div className="margin-top margin-bottom clearfix">&nbsp;</div>
                <div className="margin-top margin-bottom clearfix">&nbsp;</div>
                <div className="margin-top margin-bottom clearfix">&nbsp;</div>
            </div>

        } else {
            return <div id="page-wrapper" className="white padding-2p-on-mobile border-on-tablet margin-1p-on-tablet">
                <div className="success-message text-left  padding-sides-medium ">
                    <span className="icon ico-clock-repeat"></span>
                    <span>Spajanje na server, molim pričekajte...</span>
                </div>
                <div className="margin-top margin-bottom clearfix">&nbsp;</div>
                <div className="margin-top margin-bottom clearfix">&nbsp;</div>
                <div className="margin-top margin-bottom clearfix">&nbsp;</div>
            </div>
        }
    }
};
